if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        $(".select-error").remove();
        var proceed = true;
        $(".custom-variant-options")
          .find(".select__select")
          .css({
            border: "0px solid #d61536",
            "border-top-right-radius": "0px",
            "border-top-left-radius": "0px",
          });
        // $('variant-selects').css({"border":"0px solid #d61536"});
        $("variant-selects")
          .parent(".variant-block-container")
          .css({
            border: "0px solid #d61536",
            "border-top-right-radius": "0px",
            "border-top-left-radius": "0px",
          });

        $("variant-selects").each(function () {
          console.log($(this).find("select").val());
          if ($(this).find("select").val() === 'select') {
            $(this).find(".custom-variant-options")
              .after(`<div class="select-error select-error-size caption_2" style="color:#d61530;margin:1px 0px 0rem;">
                      <span class="errormsg detail_8 mobile_body_8" style="font-size:14px;font-weight:600;">Required</span>
                    </div>`);
            proceed = false;
            $(".custom-variant-options")
              .find(".select__select")
              .css({ border: "2px solid #d61536", "border-radius": "0px" });
            $("variant-selects")
              .parent(".variant-block-container")
              .css({ border: "2px solid #d61536", "border-radius": "0px" });

            $([document.documentElement, document.body]).animate(
              {
                scrollTop: $("#variantblockcontainer").offset().top - 90,
              },
              500
            );
          }
        });

        $("variant-radios").each(function () {
          if ($("variant-radios").find("input:checked").length == 0) {
            $(this).find(".product-form__input-radio")
              .after(`<div class="select-error select-error-size caption_2" style="color:#d61530; padding:0px 0px 1.5rem; ">
                      
                      <span class="errormsg detail_8 mobile_body_8" style="font-size:14px;font-weight:600;">Required</span>
                    </div>`);
             $("variant-radios")
              .parent(".variant-block-container")
              .css({ border: "2px solid #d61536", "border-radius": "0px" });
            proceed = false;
            $([document.documentElement, document.body]).animate(
              {
                scrollTop: $("#variantblockcontainer").offset().top - 90,
              },
              1000
            );
          }
        }); 
       
        
        if (proceed == false) {
          return;
        }
         
        var this2 = this;
        if ($('.component-item[data-included="0"]').length != 0) {
          var items = [];
          $('.component-item[data-included="0"]').each(function () {
            if ($(this).find(".component-qty-main").val() != 0) {
              var jsob = {};
              jsob["id"] = $(this).data("productid");
              jsob["quantity"] = $(this).find(".component-qty-main").val();
              var image = {};
              image["_Image"] =
                "https:" +
                $(this).find(".image-container").find("img").attr("src");
              jsob["properties"] = image;
              items.push(jsob);
            }
          });
          console.log(items + " gggg");
          if (items.length > 0) {
            let formData = {
              items: items,
            };
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            })
              .then((response) => {
                return response.json();
              })
              .then((response) => {
                continuePurchase();
              })
              .catch((error) => {
                console.error("Error:", error);
              });
          } else {
            continuePurchase();
          }
        } else {
          continuePurchase();
        }

        function continuePurchase() {
          this2.handleErrorMessage();

          this2.submitButton.setAttribute("aria-disabled", true);
          this2.submitButton.classList.add("loading");
          this2.querySelector(".loading__spinner").classList.remove("hidden");

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          // var freestr = "";
          // if ($('.component-item[data-included="1"]').length != 0) {
          //   $('.component-item[data-included="1"]').each(function () {
          //     var quantity = Number(
          //       $(this).find(".component-qty-main").attr("step")
          //     );
          //     for (let i = 0; i < quantity; i++) {
          //       freestr = freestr + "," + $(this).attr("data-mainpid");
          //     }
          //   });
          // }
          // if (freestr != "") {
          //   if ($(".inputincluded").length == 0) {
          //     $(".product-form__submit").before(
          //       '<input hidden class="inputincluded" name="properties[_Included]" value="' +
          //         freestr.substring(1) +
          //         '" type="text"/>'
          //     );
          //   }
          // }

          const formData = new FormData(this2.form);
          if (this2.cart) {
            formData.append(
              "sections",
              this2.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);

            this2.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this2.handleErrorMessage(response.description);

                const soldOutMessage =
                  this2.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this2.submitButton.setAttribute("aria-disabled", true);
                this2.submitButton
                  .querySelector("span")
                  .classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this2.error = true;
                return;
              } else if (!this2.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this2.error = false;
              const quickAddModal = this2.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this2.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this2.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this2.submitButton.classList.remove("loading");
              if (this2.cart && this2.cart.classList.contains("is-empty"))
                this2.cart.classList.remove("is-empty");
              if (!this2.error)
                this2.submitButton.removeAttribute("aria-disabled");
              this2.querySelector(".loading__spinner").classList.add("hidden");
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          $(".custom-collapsible-title")
            .unbind()
            .click(function (e) {
              e.preventDefault();
              let $this = $(this);
              if ($this.next().hasClass("show")) {
                $this.next().removeClass("show");
                $this.next().slideUp(350);
                $(".custom-collapsible-title ").removeClass("active");
                $this
                  .find(".collapsible-icon-container")
                  .find(".plus")
                  .css({ display: "flex" });
                $this
                  .find(".collapsible-icon-container")
                  .find(".minus")
                  .css({ display: "none" });
              } else {
                $this
                  .parent()
                  .parent()
                  .find(".custom-collapsible-title")
                  .removeClass("active");
                $this
                  .parent()
                  .parent()
                  .find(".custom-collapsible-content")
                  .removeClass("show");
                $this
                  .parent()
                  .parent()
                  .find(".custom-collapsible-content")
                  .slideUp(350);

                $this
                  .parent()
                  .parent()
                  .find(".collapsible-icon-container")
                  .find(".plus")
                  .css({ display: "flex" });
                $this
                  .parent()
                  .parent()
                  .find(".collapsible-icon-container")
                  .find(".minus")
                  .css({ display: "none" });
                $this.toggleClass("active");
                $this.next().toggleClass("show");
                $this.next().slideToggle(350);

                $this
                  .find(".collapsible-icon-container")
                  .find(".plus")
                  .css({ display: "none" });
                $this
                  .find(".collapsible-icon-container")
                  .find(".minus")
                  .css({ display: "flex" });
              }

              $(".custom-collapsible-inner-content").css({ display: "none" });
            });

          $(".custom-collapsible-inner-title")
            .unbind()
            .click(function (e) {
              e.preventDefault();

              let $this = $(this);

              if ($this.next().hasClass("show")) {
                $this.next().removeClass("show");
                $this.next().slideUp(350);

                $this
                  .find(".collapsible-icon-container")
                  .find(".plus")
                  .css({ display: "flex" });
                $this
                  .find(".collapsible-icon-container")
                  .find(".minus")
                  .css({ display: "none" });
              } else {
                $this
                  .parent()
                  .parent()
                  .find(".custom-collapsible-inner-content")
                  .removeClass("show");
                $this
                  .parent()
                  .parent()
                  .find(".custom-collapsible-inner-content")
                  .slideUp(350);

                $this
                  .parent()
                  .parent()
                  .find(".collapsible-icon-container")
                  .find(".plus")
                  .css({ display: "flex" });
                $this
                  .parent()
                  .parent()
                  .find(".collapsible-icon-container")
                  .find(".minus")
                  .css({ display: "none" });

                $this.next().toggleClass("show");
                $this.next().slideToggle(350);

                $this
                  .find(".collapsible-icon-container")
                  .find(".plus")
                  .css({ display: "none" });
                $this
                  .find(".collapsible-icon-container")
                  .find(".minus")
                  .css({ display: "flex" });
              }
            });
          $(".custom-collapsible-title").eq(0).click();
        };
        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }
    }
  );
}
